import { UnflownAirway, UnflownAirwayOrder, UnflownAirwayRefundStatus } from "~/application/types";
import { UnflownAirwayDTO, UnflownAirwayOrderDTO } from "../dtos";
import { toDate } from "~/utils/date.utils";

export const mapUnflownAirway = (data: UnflownAirwayDTO): UnflownAirway => {
  return {
    uuid: data.uuid,
    passengersTravelersId: data.passengers_travelers_uuid,
    value: data.credit_value,
    status: data.status,
    originalAirwayOrder: mapUnflownAirwayOrder(data.original_airway_order),
    newAirwayOrder: data.new_airway_order ? mapUnflownAirwayOrder(data.new_airway_order) : null,
    ticket: data.ticket,
    airline: data.airline,
    issueDate: data.issue_date ? toDate(data.issue_date) : new Date(),
    changeTax: data.change_tax,
    expiredAt: toDate(data.expired_at),
    passengerName: data.passenger_name,
    refundRequestedAt: data.refund_requested_at ? toDate(data.refund_requested_at) : null,
    refundStatus: data.refund_status ?? UnflownAirwayRefundStatus.REQUESTED,
    refundRequesterId: data.refund_requester_uuid,
    customer: data.customer
      ? {
          uuid: data.customer.uuid,
          companyName: data.customer.company_name,
          tradingName: data.customer.trading_name,
        }
      : null,
  };
};

const mapUnflownAirwayOrder = (data: UnflownAirwayOrderDTO): UnflownAirwayOrder => {
  return {
    uuid: data.uuid,
    tracker: data.tracker,
    orderId: data.order_uuid,
    orderNumber: data.order_number,
  };
};
